<script setup lang="ts">
  const store = useProjectStore()
  const { profileDrawer } = storeToRefs(store)

  const helpPopup = ref(false)
</script>
<template>
  <div v-if="profileDrawer.shown">
    <div @click="helpPopup = true" class="help-icon" v-show="!helpPopup">
      <v-icon> mdi-help</v-icon>
    </div>
    <v-scale-transition v-show="helpPopup">
      <div class="top-left-box">
        <v-icon class="float-right" @click="helpPopup = false"> mdi-close</v-icon>
        <strong>Section line</strong>
        <p>Left-click on the section line to select the element.</p>
        <br />
        <strong>Ground investigation points</strong>
        <p>Left-click on the ground investigation points to select multiple elements.</p>
        <p>
          Right-click the ground investigation points to (de)select multiple elements for a section
          line.
        </p>
        <br />
        <strong>Polygons</strong>
        <p>Left-click the polygon to select the element.</p>
        <p>Right-click the polygon to delete or edit the name of the element(s).</p>
      </div>
    </v-scale-transition>
  </div>
</template>

<style scoped>
  .help-icon {
    cursor: pointer;
    position: absolute;
    border-radius: 100px;
    bottom: 2%;
    left: 2%;
    z-index: 1000;
    background-color: white;
    padding: 10px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .top-left-box {
    position: absolute;
    width: 30%;
    border-radius: 5px;
    bottom: 2%;
    left: 2%;
    z-index: 1000;
    background-color: white;
    padding: 10px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
</style>
